export default {
  assistance: {
    name: 'Assistance',
    question: 'Do you have questions? ',
    centreOuvert:
      'We are at your service at 01 42 22 54 90 from Monday to Friday 7:30 a.m. to 6:00 p.m.',
    envoyerMail: 'Send an email',
    gestionnaire: 'Your administrator',
    telephone: 'Phone',
    gestionRDV: {
      libelle: 'Manage your appointments',
      email: 'bilan@leciem.org',
    },
    relationClient: {
      libelle: 'Your customer relationship',
      email: 'relationclient@leciem.org',
    },
    suiviMedical: {
      libelle: 'Your medical follow-up',
      email: 'suivimedical@leciem.org',
      telephone: '',
    },
    qualite: {
      libelle:
        'make a complaint or send us your comments on the progress of the assessment',
      email: '',
      telephone: '',
    },
  },
}
